export const RECIPIENT_SEGMENT_PREFIX = 'Recipient - ';
export const RECIPIENT_APP_NAME = 'new_recipient';
